import request from '@/config/axios'
export const getNotifyPage = (params: PageParam & { userNickname?: string; notifyType?: number; isRead?: boolean }) =>
  request.get({ url: '/bosscircle/notify/page', params })
export const getNotifyUserOptions = (keyword: string) => request.get({ url: '/bosscircle/notify/user-options', params: { keyword } })
export const createNotify = (data: { userId: number; content: string }) => request.post({ url: '/bosscircle/notify/create', data })
export const deleteNotify = (id: number) => request.delete({ url: '/bosscircle/notify/delete', params: { id } })
